/* eslint-disable */
export default {
    bind: function (el) {
        el.addEventListener('click', function (e) {
            const buttonClicked = e.target;
            // get the value of the data attribute of the button clicked and store it in a variable for later use
            // const buttonClickedValue = buttonClicked.getAttribute('aria-expanded');
            // get the value of the data attribute of the button collapse text
            const buttonCollapseTextValue = buttonClicked.getAttribute('data-collapse-text');
            // get the value of the data attribute of the button expand text
            const buttonExpandTextValue = buttonClicked.getAttribute('data-expand-text');
            // get the content element that is related to the button clicked and has the class fixed-image and store it in a variable for later use
            const contentElementFixedImage = e.target.parentElement;
            // // get the parent element of contentElementFixedImage and store it in a variable for later use
            const contentElement = contentElementFixedImage.parentElement;
            // //get the parent element of contentElement and store it in a variable for later use
            const contentElementParent = contentElement.parentElement;
            // // get the sibling element of contentElementParent and store it in a variable for later use
            const contentElementSibling = contentElementParent.parentElement;
            // get the content element that has the class fixed-image and store it in a variable for later use
            const contentElementFixedImageSibling = contentElementSibling.querySelector('.image-fixed');
            // console.log(contentElementSibling)

            if(buttonClicked.innerHTML.trim() === buttonExpandTextValue){
                let contentElement = buttonClicked.previousElementSibling;
                contentElement.classList.add('show');
                // console.log(contentElement, contentElement.classList)
                //add class 'expanded-text' to c-promo
                contentElementParent.classList.add('expanded-text');
                // //change the text of the button to 'Expand to see more'
                buttonClicked.innerHTML = buttonCollapseTextValue || 'Collapse to see less';

                if (window.innerWidth > 425 && buttonClicked.innerHTML.trim() === buttonCollapseTextValue) {
                    contentElementFixedImageSibling.style.position = 'sticky';
                    contentElementFixedImageSibling.style.top = '70px';
                    contentElementFixedImageSibling.classList.add('img-expanded-pos');
                    console.log('inside 1');
                }
            } else {
                let contentElement = buttonClicked.previousElementSibling;
                contentElement.classList.remove('show');
                // console.log(contentElement, contentElement.classList)
                //remove class 'expanded-text' from .c-promo
                contentElementParent.classList.remove('expanded-text');
                buttonClicked.innerHTML = buttonExpandTextValue || 'Expand to see more';

                if (window.innerWidth > 425 && buttonClicked.innerHTML.trim() === buttonCollapseTextValue) {
                    contentElementFixedImageSibling.style.position = 'relative';
                    contentElementFixedImageSibling.style.top = '0px';
                    contentElementFixedImageSibling.classList.remove('img-expanded-pos');
                    console.log('inside 2');
                }

                contentElementSibling.scrollIntoView({ block: "start", behavior: "smooth" });
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/button-collapse-content.js